import React from 'react';

interface FeatureItemProps {
  text: string;
  iconSrc?: string;
}

const FeatureItem: React.FC<FeatureItemProps> = ({
  text,
  iconSrc = 'https://cdn.prod.website-files.com/6093bce33d9b4bae841b04e3/6093bce33d9b4b1c8a1b052a_check-circle.svg',
}) => {
  return (
    <div className="flex items-start justify-start space-x-3">
      <img src={iconSrc} alt="Check" className="w-6 h-6" />
      <p className="text-gray-700 text-base text-start">{text}</p>
    </div>
  );
};

export default FeatureItem;
